import Vue from 'vue';
import { MutationTree, ActionTree, GetterTree, Module, ActionContext } from 'vuex';
import { RootState } from '../rootState';
import Toasted, { ToastOptions } from 'vue-toasted';
import removeNamespace from '../removeNamespace';

Vue.use(Toasted);

const namespace = 'notification';

export const NotificationModuleTypes = {
    getters: {},
    mutations: {},
    actions: {
        notify: `${namespace}/notify`,
    },
};

const types = removeNamespace(namespace, NotificationModuleTypes);

export enum NotificationType {
    Info = 'Info',
    Success = 'Success',
    Error = 'Error',
}

export interface NotificationPayload {
    message: string;
    type: NotificationType;
}

// tslint:disable-next-line: no-empty-interface
export interface NotificationState { }

const state: NotificationState = {};

const mutations: MutationTree<NotificationState> = {};

const actions: ActionTree<NotificationState, RootState> = {
    [types.actions.notify](context: ActionContext<NotificationState, RootState>, payload: NotificationPayload): void {
        const toastOptions: ToastOptions = {
            duration: 5000,
            theme: 'toasted-primary',
            position: 'bottom-center',
        };

        switch (payload.type) {
            case NotificationType.Info:
                toastOptions.type = 'info';
                break;
            case NotificationType.Success:
                toastOptions.type = 'success';
                break;
            case NotificationType.Error:
                toastOptions.type = 'error';
                break;
        }
        Vue.toasted.show(payload.message, toastOptions);
    },
};

const getters: GetterTree<NotificationState, RootState> = {};

const module: Module<NotificationState, RootState> = {
    state,
    mutations,
    actions,
    getters,
    namespaced: true,
};

export default module;
